import { useRouter } from "next/router";
import { useCallback } from "react";

export default function useUrlWithPreview() {
  const router = useRouter();

  return useCallback(
    (url: string): string => {
      const previewLayout = router.query.preview_layout?.toString();
      if (!previewLayout) return url;

      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}preview_layout=${previewLayout}`;
    },
    [router.query.preview_layout]
  );
}
